import Axios, { AxiosResponse } from 'axios';
import { BASE_API_PATH } from '../enum/base.enum';
import { LogLevel } from '../enum/enum';

export const LogsService = {
    log(params: { level: LogLevel ; message: string; meta?: unknown[] }) {
        Axios.post(`${BASE_API_PATH}/logs`, params).catch(() => {});
    }
};
